module.exports = __webpack_public_path__ + "static/media/logo.3080a75d.png";